import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2242">
      <div className="dark" data-id="element-2243">
        <Hero data-id="element-2244" />
      </div>
      <WhyUs data-id="element-2245" />
      <Services data-id="element-2246" />
      <HowItWorks data-id="element-2247" />
      <FAQ data-id="element-2248" />
      <Reviews data-id="element-2249" />
      <CtaBanner data-id="element-2250" />
    </main>;
}